<template>
  <v-dialog
    :value="dialog"
    :max-width="400"
    persistent
    :retain-focus="false"
    @keydown.esc="escape(closeDialog)"
    @click:outside="escape(closeDialog)"
    @keydown.enter="submit"
  >
    <v-card outlined>
      <v-card-title>
        {{ eventCategory ? $t('eventCategory.editCategory') : $t('eventCategory.createCategory') }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          tabindex="4"
          @click="escape(closeDialog)"
        ></p-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" @submit.stop.prevent>
          <v-container>
            <v-row dense align="center" justify="end">
              <v-col>
                <v-text-field
                  type="text"
                  v-model.trim="editedEventCategory.name"
                  :rules="rules.name"
                  :label="$t('eventCategory.edit.name')"
                  tabindex="1"
                  clearable
                  autofocus
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn text tabindex="3" @click="closeDialog">{{ $t('cancel') }}</v-btn>
        <v-btn text :disabled="!isModelChanged()" tabindex="2" color="primary" @click="submit">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

import PBtnIcon from '@/components/PBtnIcon'

import snackbarMixin from '@/mixins/snackbar.mixin'
import objectMixin from '@/mixins/object.mixin'
import dialogMixin from '@/mixins/dialog.mixin'
import validationMixin from '@/mixins/validation.mixin'
import unsavedChangesMixin from '@/mixins/unsavedChanges.mixin'
import errorMixin from '@/mixins/error.mixin'


export default {
  components: {
    PBtnIcon
  },


  mixins: [
    snackbarMixin,
    objectMixin,
    dialogMixin,
    validationMixin,
    unsavedChangesMixin,
    errorMixin
  ],


  props: {
    eventCategory: Object
  },


  data () {
    return {
      editedEventCategory: {},
      defaultEventCategory: {
        name: ''
      },
      existingEventCategoryNames: []
    }
  },


  computed: {
    ...mapGetters('season', ['currentSeasonId']),

    rulesToApply () {
      const rule = this.rule

      return {
        name: [
          rule.required(),
          rule.unique(this.existingEventCategoryNames, this.$t('eventCategory.edit.nameExists'))
        ]
      }
    }
  },


  methods: {
    ...mapActions('eventCategory', ['createEventCategory', 'updateEventCategory']),
    ...mapActions('changes', ['removeFromChanges']),

    onDialogOpen () {
      if (this.eventCategory) {
        this.removeFromChanges(this.eventCategory)
      }
      this.existingEventCategoryNames = []
      this.editedEventCategory = this.getObjectCopy(this.eventCategory || this.defaultEventCategory)
      this.initWatchedModel(this.editedEventCategory)
      this.resetValidation()
    },

    async submit () {
      const valid = await this.validate(this.rulesToApply)
      if (!valid || !this.isModelChanged()) return

      try {
        this.showSnackbarProcessing()
        const eventCategory = this.getObjectCopy(this.editedEventCategory)
        eventCategory.event = parseInt(eventCategory.event)

        if (eventCategory.id) {
          await this.updateEventCategory(eventCategory)
          this.showSnackbarSuccess(this.$t('eventCategory.categoryUpdated'))
        } else {
          eventCategory.seasonId = this.currentSeasonId
          await this.createEventCategory(eventCategory)
          this.showSnackbarSuccess(this.$t('eventCategory.categoryCreated'))
        }
        this.closeDialog()
      } catch (error) {
        if (this.is409ConflictError(error)) {
          this.hideSnackbar()
          this.existingEventCategoryNames.push(this.editedEventCategory.name)
          this.validate(this.rulesToApply)
        } else {
          this.showSnackbarError()
        }
        this.$log.error(error)
      }
    }
  }
}
</script>
